import type { TableFilterField } from '@shared/ui';
import type { VacancyFiltersForm } from './types';

export const RESPONSIBLE_USER_ID_SEARCH_PARAM = 'responsibleUserId';

export const vacancyFiltersConfig: TableFilterField[] = [
  {
    name: 'name',
    label: 'Вакансия',
    type: 'text' as const,
    placeholder: 'Все',
  },
  {
    name: 'createdAt',
    label: 'Дата создания',
    type: 'date-range' as const,
    placeholder: 'Все',
  },
  {
    name: 'company',
    label: 'Компания',
    type: 'select-company' as const,
    placeholder: 'Все',
    apiKey: 'company.id',
  },
  {
    name: 'city',
    label: 'Город',
    type: 'select-city' as const,
    placeholder: 'Все',
    apiKey: 'cities.name',
  },
  {
    name: RESPONSIBLE_USER_ID_SEARCH_PARAM,
    label: 'Сотрудник',
    type: 'select-recruiter' as const,
    placeholder: 'Все',
    apiKey: 'responsibleUser.id',
  },
  {
    name: 'status',
    label: 'Статус',
    type: 'select' as const,
    // Todo-Omarov доработать компонент TableFilters и брать статусы из /vacancies/statuses
    options: [
      { value: 'new', label: 'Новая' },
      { value: 'selection_in_progress', label: 'Идет подбор' },
      { value: 'selection_suspended', label: 'Подбор приостановлен' },
      { value: 'selection_cancelled', label: 'Подбор отменен' },
      { value: 'selection_completed', label: 'Подбор выполнен' },
      { value: 'archived', label: 'В архиве' },
    ],
    clearable: true,
    placeholder: 'Все',
  },
];

export const candidateProposedVacancyFiltersConfig: TableFilterField[] =
  vacancyFiltersConfig.map(field =>
    field.name === 'city' ? { ...field, apiKey: 'city.name' } : field
  );

export const initialValues: VacancyFiltersForm = {
  name: '',
  createdAt: [null, null],
  company: null,
  city: [],
  responsibleUserId: null,
  status: null,
};
